/********************* announcement bar for slick slider*******************/ 
/** Home page shop by collection  collection **/
 $(document).ready(function(){

    
  $('#shopify-section-template--15967276335354__165165410889136316 .brands-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  dots: false,
  arrow: true,
  nextArrow: true,  
  autoplaySpeed: 2000,     
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay:true,
        centerMode: true,
        centerPadding: '20px',
        infinite: true,
      }
    }
  ]
});
   
   
//    shop by collection
       $('.collslider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  dots: false,
  arrow: true,
  nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>', 
  prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
  autoplaySpeed: 2000,     
 responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,  
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
   
   



    // handmade section
   
    $('.slider-video_handmade').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>', 
            prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
            {
              breakpoint: 1024,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
              }
            },
            {
              breakpoint: 768,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
              }
             }
            ],
       });  

// Ziddi Tribe

   $('.ziddi_tribe').slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplaySpeed: 1500,
            arrows: true,
            nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>', 
            prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
            dots: false,
            autoplay: true,
       responsive: [
         {
          breakpoint: 1024,
          settings: {
                dots: false,
                slidesToShow: 3,
                autoplay:true
          }
        },
        {
          breakpoint: 768,
            settings: {
                slidesToShow: 1,
                dots: false,
                autoplay:true,
                centerMode: true,
                infinite: true,
          }
        }
      ]
    });

   
});
   
$(document).ready(function(){
      if ($(window).width() < 550) {
        $('.logo-bar').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000
          //         dots: true,
          //         arrows: true,
        });
      }
  
  $('.off_widget_inner').click(function(){
   $('#popup').addClass('visible');
    $('#slide-up').show();
    });
    });

$(document).ready(function(){
    $('.accordian_cstm').click(function(e) {
   e.preventDefault();
    let $this = $(this);
    if ($this.hasClass('show-acc')) {
      $this.removeClass('show-acc');
      $this.next().slideUp(350);
    } else {
     $this.parents('.parent_acc').find('.accordian_drop').removeClass('show-acc');
      $this.parents('.parent_acc').find('.accordian_drop').slideUp(350);
      $this.toggleClass('show-acc');
      $this.next().slideToggle(350);
    }
});
});

